/*global chrome*/
import debugTools from "../evaluation/debug";

const getImpersonatorData = async (impersonatorExtensionId) => {
    return new Promise((resolve, reject) => {
        chrome?.runtime?.sendMessage(
            impersonatorExtensionId,
            { message: { readyForMockValues: true } },
            (response) => {
                if (response.mockValues) {
                    debugTools.info(`Received mock values from Impersonator of ${ JSON.stringify(response.mockValues) }`);
                } else {
                    debugTools.error("Failed to receive mock values from Impersonator");
                }

                resolve(response.mockValues);
            }
        );
    });
};

export default getImpersonatorData;
